import {
  ENV_KEY,
  RUNTIME_KEY,
  UNLOCK_KEY,
  OPS_PASSWORD,
  pathsStorageKey,
  secretsStorageKey,
  seedPaths,
  seedSecrets,
  type OpsEnvironment,
  type OpsRuntime,
  type SecretsConfig,
  type ServicePathsMap,
} from './opsConsoleData';

export function isOpsUnlocked(): boolean {
  try {
    return sessionStorage.getItem(UNLOCK_KEY) === '1';
  } catch {
    return false;
  }
}

export function unlockOpsConsole(password: string): boolean {
  if (password !== OPS_PASSWORD) return false;
  try {
    sessionStorage.setItem(UNLOCK_KEY, '1');
  } catch {
    /* ignore */
  }
  return true;
}

export function lockOpsConsole(): void {
  try {
    sessionStorage.removeItem(UNLOCK_KEY);
  } catch {
    /* ignore */
  }
}

export function readEnv(): OpsEnvironment {
  try {
    const v = localStorage.getItem(ENV_KEY);
    if (v === 'dev' || v === 'staging' || v === 'production') return v;
  } catch {
    /* ignore */
  }
  return 'dev';
}

export function writeEnv(env: OpsEnvironment): void {
  try {
    localStorage.setItem(ENV_KEY, env);
  } catch {
    /* ignore */
  }
}

export function readRuntime(): OpsRuntime {
  try {
    const v = localStorage.getItem(RUNTIME_KEY);
    if (v === 'no-docker' || v === 'docker' || v === 'k8s') return v;
  } catch {
    /* ignore */
  }
  return 'no-docker';
}

export function writeRuntime(runtime: OpsRuntime): void {
  try {
    localStorage.setItem(RUNTIME_KEY, runtime);
  } catch {
    /* ignore */
  }
}

export function loadPaths(env: OpsEnvironment, runtime: OpsRuntime): ServicePathsMap {
  try {
    const raw = localStorage.getItem(pathsStorageKey(env, runtime));
    if (raw) {
      const parsed = JSON.parse(raw) as ServicePathsMap;
      return { ...seedPaths(env, runtime), ...parsed };
    }
  } catch {
    /* ignore */
  }
  return seedPaths(env, runtime);
}

export function savePaths(env: OpsEnvironment, runtime: OpsRuntime, paths: ServicePathsMap): void {
  try {
    localStorage.setItem(pathsStorageKey(env, runtime), JSON.stringify(paths));
  } catch {
    /* ignore */
  }
}

export function resetPaths(env: OpsEnvironment, runtime: OpsRuntime): ServicePathsMap {
  const seeded = seedPaths(env, runtime);
  savePaths(env, runtime, seeded);
  return seeded;
}

export function loadSecrets(env: OpsEnvironment): SecretsConfig {
  try {
    const raw = localStorage.getItem(secretsStorageKey(env));
    if (raw) {
      const parsed = JSON.parse(raw) as SecretsConfig;
      return { ...seedSecrets(env), ...parsed };
    }
  } catch {
    /* ignore */
  }
  return seedSecrets(env);
}

export function saveSecrets(env: OpsEnvironment, secrets: SecretsConfig): void {
  try {
    localStorage.setItem(secretsStorageKey(env), JSON.stringify(secrets));
  } catch {
    /* ignore */
  }
}

export function resetSecrets(env: OpsEnvironment): SecretsConfig {
  const seeded = seedSecrets(env);
  saveSecrets(env, seeded);
  return seeded;
}
